import React, {Component} from 'react';
// Needed for onTouchTap
import './UserForm.css';
import T from 'i18n-react';
// WebServices
import ShopService from '../../services/ShopService';
// Composants
import ItemDropdown from '../dropdownIdName/DropdownIdName';
import KeyboardArrowDownIcon from 'react-material-icons/icons/hardware/keyboard-arrow-down';
import ProfileDropdown from '../ProfileDropdown/ProfileDropdown';
import RaisedButton from 'material-ui/RaisedButton';
import Chip from 'material-ui/Chip';
import MaterialFormInput from '../materialFormInput/MaterialFormInput';
import AutoCompleteInput from '../autoCompleteInput/AutoCompleteInput';
import DropDownMenu, {MenuItem} from 'material-ui/DropDownMenu';
import HelpIcon from 'material-ui/svg-icons/action/help';
import DialogText from "../dialogLongText/DialogText";
// Enum
import COLORS from '../../enums/ColorEnum';
import PROFILES from '../../enums/ProfileEnum';
// Utils
import {makeCancelable} from '../../utils/PromiseUtils';
// User form utils
import {getFieldData, requiredFieldsForm, validateField} from './UserFormUtils';
import {Checkbox} from "material-ui";
import UserService from "../../services/UserService";
import {getDistinctValues} from "../../utils/JSUtils";

const inputConfigs = {
    fullWidth: true,
    errorStyle: {
        color: COLORS.RED,
    },
    inputStyle: {
        color: COLORS.BLACK
    },
    floatingLabelStyle: {
        color: COLORS.BLACK
    },
    floatingLabelFocusStyle: {
        color: COLORS.GREY,
    }
};

const buttonConfigs = {
    backgroundColor: COLORS.GREEN,
    labelColor: COLORS.WHITE,
    fullWidth: true,
    style: {
        marginTop: '20px'
    }
};

const dropdownConfigs = {
    color: COLORS.BLACK,
    style: {
        width: '100%',
        color: COLORS.BLACK,
        paddingLeft: '0'
    },
    labelStyle: {
        paddingLeft: '0'
    },
    underlineStyle: {
        width: '100%',
        margin: '0'
    },
    iconStyle: {
        fill: COLORS.BLACK
    },
    iconButton: <KeyboardArrowDownIcon/>,
    menuStyle: {
        width: '320px'
    }
};

class UserForm extends Component {

    /*************************************************
     * **************** LifeCycle ********************
     *************************************************/

    constructor(props) {
        super(props);

        // Si on a fourni un client dans les props (clients de l'utilisateur à éditer ou création d'un utilisateur avec un client imposé) on la récupère
        // Sinon on met un tableau vide en attendant l'appel au webservice
        let clientList = props.userData.client ? [props.userData.client] : [];
        // Si on a fourni une bu dans les props (bu de l'utilisateur à éditer ou création d'un utilisateur avec une bu imposée) on la récupère
        // Sinon on met un tableau vide en attendant l'appel au webservice
        let buList = props.userData.bu ? [props.userData.bu] : [];
        // Si il n'y a pas de profile spécifié on met le profile
        // user par défaut (simple utilisateur)
        const profile = props.userData.profile || PROFILES.USER;
        const canManageUsers = !!props.userData.canManageUsers;
        // Si on a fourni un shop dans les props (shop de l'utilisateur à éditer ou création d'un utilisateur avec un shop imposé) on le récupère
        // Sinon on met un tableau vide en attendant l'appel au webservice
        let shopList = props.userData.shop ? [props.userData.shop] : [];

        //Si on a pas de location (création) alors on met le pays de l'utilisateur connecté
        let location = props.userData.locationList && props.userData.locationList.length > 0 ? props.userData.locationList[0] : props.connectedUserInformation.locationList[0];
        // Si on veut modifier un utilisateur alors on récupére directement les listes depuis userData
        if (!this.props.isCreating) {
            shopList = props.userData.shopList;
            buList = props.userData.businessUnitList;
            clientList = props.userData.clientList;
        }

        this.state = {
            clientList,
            buList,
            shopList,
            fields: {
                bu: props.userData.bu || (props.userData.buList ? props.userData.buList[0] : undefined),
                buList: buList,
                shopList: shopList,
                client: props.userData.client || (props.userData.clientList ? props.userData.clientList[0] : undefined),
                clientList: clientList,
                profile,
                canManageUsers: canManageUsers,
                shop: props.userData.shop || (props.userData.shopList ? props.userData.shopList[0] : undefined),
                location: location, 
                login: props.userData.login || '',
                firstName: props.userData.firstName || '',
                lastName: props.userData.lastName || '',
                email: props.userData.email || '',
                phoneNumber: props.userData.phoneNumber || ''
            },
            errors: {},
            isValid: false,
            isWarningDialogOpen: true
        };
    }

    componentWillMount() {
        const connectedUserProfile = this.props.connectedUserInformation.profile;
        //On récupère les informations de l'utilisateur connecté
        if(this.props.connectedUserInformation) {
            this.setState((state, props) => ({
                clientList: props.connectedUserInformation.clientList.filter(client => client.location === state.fields.location),
                buList: props.connectedUserInformation.businessUnitList,
                shopList: props.connectedUserInformation.shopList
            }));
        }
        //Si il n'y a qu'un seul client lors de l'edition, on récupère ses bu (cas User et SuperUser ignorés car leur bu ne sont liés qu'a un client)
        if(!this.props.isCreating && connectedUserProfile !== PROFILES.USER && connectedUserProfile !== PROFILES.SUPER_USER && this.props.userData.clientList && this.props.userData.clientList.length === 1){
            this.setState((state, props) => ({
                buList: props.connectedUserInformation.businessUnitList.filter(bu => bu.idClient === props.userData.clientList[0].id)
            }));
        }
        //Si il n'y a qu'une seule bu lors de l'edition, on récupère ses shops, (cas User ignoré car ils n'ont qu'un seul shop et une seule bu)
        if (!this.props.isCreating && connectedUserProfile !== PROFILES.USER && this.props.userData.buList && this.props.userData.buList.length === 1) {
          this.setState((state, props) => ({
            shopList: this.getShopListWithoutSelect(props.userData.buList[0].id)
          }));
        }

        // On valide le formulaire une première fois avant que l'utilisateur y ai accès
        this.validateForm();
    }

    /**
     * Annulation de toutes les promesses encore en cours lorsque
     * l'on quitte le composant
     */
    componentWillUnmount() {
        this._promises.forEach(promise => promise.cancel());
    }

    render() {
        // On affiche la liste des pays si on est admin MP et si on veut créer / modifier un User, Super User ou un Admin
        const shouldDisplayLocationMenu = this.props.isAdmin && this.state.fields.profile !== PROFILES.ADMIN_MP;
        const connectedUserProfile = this.props.connectedUserInformation.profile;
        const disableCanManageUsers = !UserService.canEditManagementRights(this.props.connectedUserInformation.profile, this.state.fields.profile);

        return (
            <form onSubmit={this.onSubmit}>
                <DialogText
                    title={T.translate('userForm.warningDialogTitle')}
                    errorMessage={T.translate('userForm.warningDialogMessage')}
                    open={this.state.isWarningDialogOpen}
                    onClose={() => this.handleDialogClose()}/>
                <h1 className="userFormMessage">{T.translate('userForm.message')}</h1>

                <ProfileDropdown label={T.translate('userForm.fields.profile')}
                    profileMap={this.props.profileMap}
                    selectProfile={this.selectProfile}
                    selectedProfile={this.state.fields.profile}
                    configs={dropdownConfigs}
                    disabled={this.props.isMe || connectedUserProfile === this.props.userData.profile} />

                <div className="userFormInput userManagement">
                    <div className="checkbox userManagementCheckbox">
                        <span className="userForm-label">{T.translate('userForm.fields.userManagement')}</span>
                        <Checkbox
                            className="userManagementCheckbox"
                            name="canManageUsers"
                            label={T.translate('userForm.fields.canManageUsers')}
                            checked={this.state.fields.canManageUsers}
                            onCheck={this.handleInputChange}
                            disabled={disableCanManageUsers}/>
                    </div>
                    {
                        disableCanManageUsers ? null :
                        <div className="tooltipUserManagement">
                            <HelpIcon color={COLORS.GREEN}/>
                            <span className="hooverUserManagement"> {T.translate('userForm.userManagementInfos')} </span>
                        </div>
                    }
                </div>

                {
                    shouldDisplayLocationMenu ?
                        this.renderLocationMenu()
                        : null
                }

                {
                    //Les AdminsMp ont tous les clients, on ne les affiche pas
                    this.state.fields.profile !== PROFILES.ADMIN_MP ?
                    this.renderClientList(connectedUserProfile) : null
                }

                {
                    this.state.fields.profile !== PROFILES.ADMIN_MP &&
                    this.state.fields.profile !== PROFILES.ADMIN ?
                    this.renderBuList(connectedUserProfile)
                    : null
                }
                {
                    this.state.fields.profile === PROFILES.USER ?
                    this.renderShopList(connectedUserProfile)
                    : null
                }

                <MaterialFormInput id="login"
                                   name="login"
                                   className="userFormInput"
                                   floatingLabelText={T.translate('userForm.fields.login')}
                                   value={this.state.fields.login}
                                   onChange={this.handleInputChange}
                                   errorText={this.state.errors.login}
                                   {...inputConfigs}/>

                <MaterialFormInput id="firstName"
                                   name="firstName"
                                   className="userFormInput"
                                   floatingLabelText={T.translate('userForm.fields.firstName')}
                                   value={this.state.fields.firstName}
                                   onChange={this.handleInputChange}
                                   errorText={this.state.errors.firstName}
                                   {...inputConfigs}/>

                <MaterialFormInput id="lastName"
                                   name="lastName"
                                   className="userFormInput"
                                   floatingLabelText={T.translate('userForm.fields.lastName')}
                                   value={this.state.fields.lastName}
                                   errorText={this.state.errors.lastName}
                                   onChange={this.handleInputChange}
                                   {...inputConfigs}/>

                <MaterialFormInput id="email"
                                   name="email"
                                   className="userFormInput"
                                   floatingLabelText={T.translate('userForm.fields.email')}
                                   value={this.state.fields.email}
                                   errorText={this.state.errors.email}
                                   onChange={this.handleInputChange}
                                   {...inputConfigs}/>
                
                <MaterialFormInput id="phoneNumber"
                                   name="phoneNumber"
                                   className="userFormInput"
                                   floatingLabelText={T.translate('userForm.fields.phoneNumber')}
                                   value={this.state.fields.phoneNumber}
                                   errorText={this.state.errors.phoneNumber}
                                   onChange={this.handleInputChange}
                                   {...inputConfigs}/>

                {this.props.userFormError ?
                    <div className="userFormSubmitError">{T.translate(this.props.userFormError)}</div>
                    : null
                }

                <RaisedButton label={T.translate('userForm.submit')}
                              className="userFormSubmitButton"
                              type="submit"
                              disabled={!this.state.isValid}
                              {...buttonConfigs}/>
            </form>
        );
    }

    /*************************************************
     ********** Render composants *************
     *************************************************/

    renderClientList = (connectedUserProfile) => {
        if((connectedUserProfile === PROFILES.ADMIN_MP|| connectedUserProfile === PROFILES.ADMIN) && this.state.clientList.length > 1){
            const clientAutoCompleteConfigs = this.getAutoCompleteConfigs(!this.props.isMe);
            return (
                <div>
                    <span className="userForm-label">{T.translate('userForm.fields.client')}</span>
                    <div className="userFormChipContainer">
                        {
                            this.state.fields.clientList.map((client, index) => {
                                return <div key={client.id}
                                            className="userFormChip">
                                    <Chip onRequestDelete={() => {
                                        if (!this.props.isMe) {
                                            this.removeSelectClient(index)
                                        }
                                    }}>
                                        {client.name}
                                    </Chip>
                                </div>;
                            }, this)

                        }
                    </div>
                    <AutoCompleteInput
                        name="client"
                        dataSource={this.state.clientList}
                        hintText={T.translate('userForm.fields.clientPlaceHolder')}
                        disabled={this.props.isMe}
                        configs={clientAutoCompleteConfigs}
                        selectItem={this.selectClient}
                    />
                </div>
            )
        } else {
            return (
                <div>
                    <span className="userForm-label">{T.translate('userForm.fields.client')}</span>
                    <ItemDropdown itemList={this.state.fields.clientList}
                                  selectedItem={this.state.fields.client || this.state.fields.clientList[0]}
                                  configs={dropdownConfigs}
                                  disabled={true} />
                </div>
            )
        }
    };

     renderBuList = (connectedUserProfile) => {
         //La selection de bu est possible si un client est sélectionné et si l'utilisateur connecté est AdminMp, Admin ou SuperUser et si ce n'est pas son compte
         const enableBuInput = !this.props.isMe && this.state.fields.client && (this.props.isAdmin || connectedUserProfile === PROFILES.ADMIN || connectedUserProfile === PROFILES.SUPER_USER);
         const buAutoCompleteConfigs = this.getAutoCompleteConfigs(enableBuInput);
          if (this.state.buList && this.state.buList.length > 1) {
            return (
            <div>
                <span className="userForm-label">{T.translate('userForm.fields.bu')}</span>
                <div className="userFormChipContainer">
                    {
                        this.state.fields.buList.map((bu, index) => {
                            return  <div key={bu.id}
                                        className="userFormChip">
                                        <Chip onRequestDelete={() => {
                                            // On peut supprimer une BU uniquement si on l'a dans sa liste
                                            if(enableBuInput && this.state.buList.some(item => item.id === bu.id)) {
                                                this.removeSelectBu(index)
                                            }
                                        }}>
                                            {bu.name}
                                        </Chip>
                                    </div>;
                        }, this)
                    }
                </div>
                <AutoCompleteInput
                    name="bu"
                    dataSource={this.state.buList}
                    hintText={T.translate('userForm.fields.buPlaceHolder')}
                    disabled={!enableBuInput}
                    configs={buAutoCompleteConfigs}
                    selectItem={this.selectBu}
                />
            </div>
            )
         }
         return (
            <ItemDropdown label={T.translate('userForm.fields.bu')}
            itemList={this.state.buList ? this.state.buList : []}
            selectedItem={this.state.fields.buList[0]}
            configs={dropdownConfigs}
            disabled={true}/>
         )
     };

     renderShopList(connectedUserProfile){
         //La selection de shop est possible si une bu est sélectionné et si l'utilisateur connecté est AdminMp, Admin ou SuperUser et si ce n'est pas son compte
         const enableShopInput = !this.props.isMe && this.state.fields.client && this.state.fields.bu && (this.props.isAdmin || connectedUserProfile === PROFILES.ADMIN || connectedUserProfile === PROFILES.SUPER_USER);
         const shopAutoCompleteConfigs = this.getAutoCompleteConfigs(enableShopInput);
         if(this.state.shopList && this.state.shopList.length > 1){
             return(
                 <div>
                     <span className="userForm-label">{T.translate('userForm.fields.shop')}</span>
                     <AutoCompleteInput
                         name="shop"
                         dataSource={this.state.shopList && this.state.fields.buList.length !== 0 ? this.state.shopList : []}
                         hintText={T.translate('userForm.fields.shopPlaceHolder')}
                         disabled={!enableShopInput}
                         configs={shopAutoCompleteConfigs}
                         selectItem={this.selectShop}
                         itemDisplayed={this.state.fields.shop}
                     />
                 </div>
             )
         } else {
             return (
                 <ItemDropdown label={T.translate('userForm.fields.shop')}
                               itemList={this.state.shopList || []}
                               selectedItem={this.state.fields.shop || this.state.fields.shopList[0]}
                               configs={dropdownConfigs}
                               disabled={true}/>
             )
         }
     }

    renderLocationMenu = () => {
        //Extraction de la listes des pays différents dans la liste de clients
        const locationList = getDistinctValues(this.props.connectedUserInformation.clientList.map(client => client.location));

        // Si on a qu'une location possible alors on renvoie un "label"
        if (locationList.length === 1) {
            return (
                <div className="userFormInput">
                    <span className="userForm-label">{T.translate('userForm.fields.location')}</span>
                    <div> {locationList[0]}</div>
                </div>
            )
        }

        let menuItemArray = [];
        
        locationList.forEach(location => {
            menuItemArray.push(<MenuItem key={location} id={location} value={location} primaryText={location} />)
        });

        return (
            <div className="dropdownIdNameContainer">
            <span className="dropDownIdNameLabel">{T.translate('userForm.fields.location')}</span>
                <DropDownMenu className="dropdownIdName locationDrop"
                            value={this.state.fields.location}
                            onChange={this.onChangeLocation}
                            disabled={this.props.isMe}>
                {menuItemArray}
            </DropDownMenu>
            </div>
        )
        
    }

    /*************************************************
     ********** Configuration composants *************
     *************************************************/

    /**
     * Retourne les configurations de style du dropdown
     * @returns {Object}
     */
    getAutoCompleteConfigs = (enableInput) => {
        return {
            input: {
                fullWidth: true,
                underlineStyle: {
                    borderBottom: '1px solid rgb(224, 224, 224)'
                }
            },
            icon: {
                style: {
                    marginRight: '31px',
                    color: enableInput ? COLORS.BLACK : COLORS.GREY,
                    fill: enableInput ? COLORS.BLACK : COLORS.GREY,
                    width: '24px'
                },
                viewBox: '0 0 20 24'
            }
        };
    };

    /*************************************************
     ******************* Actions *******************
     *************************************************/

    handleDialogClose() {
        this.setState({isWarningDialogOpen: false});
    }

    /**
     * Action déclanché lors du submit du formulaire
     * @param e
     */
    onSubmit = (e) => {
        e.preventDefault();

        const formData = this.getFormDataPreparedForRequest();
        this.props.onSubmit(formData);
    };

    removeSelectBu(index) {
        this.setState((state, props) => {
            let fields = {...state.fields};
            fields.buList.splice(index, 1);
            fields.bu = undefined;
            fields.shop = null;
            fields.shopList = [];
            return {
                fields,
                //Réinitialise l'autoComplete des magasins
                shopList: props.connectedUserInformation.shopList
            };
        }, this.validateForm);
    }

    removeSelectClient(index) {
        this.setState((state, props) => {
            let fields = {...state.fields};
            fields.clientList.splice(index, 1);
            fields.client = undefined;
            fields.buList = [];
            fields.shop = null;
            fields.shopList = [];
            return {
                fields,
                //Réinitialise l'autoComplete des magasins
                shopList: props.connectedUserInformation.shopList
            };
        }, this.validateForm);
    }

    /**
     * Séléctionne une champ (de type TextInput) puis
     * valide le formulaire
     * @param event
     */
    handleInputChange = (event) => {
        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        const name = target.name;
        // Pour le phoneNumber on met une limite (maxLength) de 19
        if (name === 'phoneNumber' && value.length === 19) {
            this.validateForm()
        } else {
            this.setState((state) => {
                let fields = {...state.fields};
                fields[name] = value;
                return {fields}
            }, this.validateForm);
        }
    };

    /**
     * Selectionne un client puis valide le formulaire
     */
    selectClient = (selectedClient) => {
        const shouldHaveOnlyOneClient = this.state.fields.profile !== PROFILES.ADMIN_MP && this.state.fields.profile !== PROFILES.ADMIN;
        let newFieldClientList =  this.state.fields.clientList;
        if (!this.state.fields.clientList.some(client => client.id === selectedClient.id)) {
            newFieldClientList =  this.state.fields.clientList.concat([selectedClient]);
        }
        this.setState((state, props) => {
            let fields = {...state.fields};
            const buList = props.connectedUserInformation.businessUnitList.filter(bu => bu.idClient === selectedClient.id);
            //Si le client n'a qu'une seule bu, on la selectionne
            if(buList.length === 1){
                this.selectBu(buList[0]);
            } else {
                fields.buList = [];
            }
            fields.client = selectedClient;
            fields.clientList = shouldHaveOnlyOneClient ? [selectedClient] : newFieldClientList;
            fields.bu = undefined;
            fields.shopList = [];
            fields.shop = null;
            return {
                fields: fields,
                buList,
                //Réinitialise l'autoComplete des magasins
                shopList: props.connectedUserInformation.shopList
            };
        }, this.validateForm);
    };

    /**
     * Selectionne une bu puis lance l'action de chargement
     * des shops en fonction de la bu séléctionné
     * (Ici on ne valide pas le formulaire car cela sera fait lors
     * de la séléction du futur shop lors du chargement de la list des shops)
     * @param selectedBu
     */
    selectBu = (selectedBu) => {
        const shouldHaveOnlyOneBu = this.state.fields.profile === PROFILES.USER;
        let newFieldBuList =  this.state.fields.buList;
        if (!this.state.fields.buList.some(bu => bu.id === selectedBu.id)) {
            newFieldBuList =  this.state.fields.buList.concat([selectedBu]);
        }
        this.setState((state) => {
            let fields = {...state.fields};
            fields.bu = selectedBu;
            fields.buList = shouldHaveOnlyOneBu ? [selectedBu] : newFieldBuList;
            return {fields};
        }, () => this.getShopList(selectedBu.id));
    };




    onChangeLocation = (event, index, value) => {
        this.setState((state, props) =>{
            let clientList = props.connectedUserInformation.clientList.filter(client => client.location === value);
            if(clientList.length === 1){
                this.selectClient(clientList[0]);
            }
            let fields = {...state.fields};
            fields.client = undefined;
            fields.clientList = [];
            fields.bu = undefined;
            fields.buList = [];
            fields.shopList = [];
            fields.shop = null;
            fields.location = value;
            return {
                clientList,
                fields
            }
        })
    };

    /**
     * Selectionne un profile puis valide le formulaire
     * @param profile
     */
    selectProfile = (profile) => {
        // Quand on change de profile on supprime toute les informations conernant la liste des BU selectionné et les shops
        this.setState((state, props) =>{
            let fields = {...state.fields};
            fields.profile = profile;
            fields.client = props.userData.client || (state.clientList.length === 1 ? state.clientList[0] : undefined);
            fields.clientList = props.userData.client ? [props.userData.client] : (state.clientList.length === 1 ? state.clientList : []);
            fields.buList = props.userData.bu ? [props.userData.bu] : (state.buList.length === 1 ? state.buList : []);
            fields.bu = props.userData.bu || (state.buList.length === 1 ? state.buList[0] : undefined);
            fields.shopList = props.userData.shop ? [props.userData.shop] : (state.shopList.length === 1 ? state.shopList : []);
            fields.shop = props.userData.shop || (state.shopList.length === 1 ? state.shopList[0] : undefined);
            fields.canManageUsers = profile === PROFILES.ADMIN_MP;
            return {fields};
        }, this.validateForm);
    };

    /**
     * Selectionne un shop puis valide le formulaire
     * @param shop
     */
    selectShop = (shop) => {
        this.setState((state) =>{
            const submitError = undefined;
            let fields = {...state.fields};
            fields.shop = shop;
            fields.shopList = [shop];
            return {
                submitError,
                fields
            }
        }, this.validateForm);
    };

    /**
     * Reset tous les champs du formulaire
     *
     * ATTENTION:
     *  - si création (admin) il faut avoir la buList et la shopList
     *      avant de lancer cette action
     *  - si création, édition (autre) il faut bien penser à donner
     *      en props le userData (sinon risque de bug)
     *
     * Utilisée uniquement lors de la création
     */
    clearForm = () => {
        this.setState((state, props) => ({
            fields: {
                clientList: props.userData.client ? [props.userData.client] : [],
                client: props.userData.client || undefined,
                buList: props.userData.bu ? [props.userData.bu] : [],
                bu: props.userData.bu || undefined,
                profile: props.userData.profile || PROFILES.USER,
                canManageUsers: false,
                shopList: props.userData.shop ? [props.userData.shop] : [],
                shop: props.userData.shop || null,
                location: state.fields.location,
                login: props.userData.login || '',
                firstName: props.userData.firstName || '',
                lastName: props.userData.lastName || '',
                email: props.userData.email || '',
                phoneNumber: props.userData.phoneNumber || ''
            }
        }));
    };

    /*************************************************
     *************** Préparation données *************
     *************************************************/

    /**
     * Retourne les données du formulaire formatté pour l'envoie du webservice
     * @returns {Object}
     */
    getFormDataPreparedForRequest = () => {
        const userProfile = this.state.fields.profile;

        const formData = {};

        // On récupère les champs à validé dans le formulaire
        // Remarque: Tous les champs sont identiques en édition d'ou la différence si dessous
        const requiredFields = requiredFieldsForm[userProfile]

        // Pour chaque champs required (en fonction du profil)
        // on récupère sa donné et on l'ajoute aux données du formulaire
        requiredFields.forEach(field => {
            const fieldData = getFieldData[field];
            formData[fieldData.key] = fieldData.getValue(this.state.fields[field]);
        });

        return formData;
    };

    /*************************************************
     ******************* Validation *******************
     *************************************************/

    /**
     * Méthode qui test tous les champs du formulaire
     * pour voir si ils sont valide ou non
     */
    validateForm = () => {
        this.props.clearError();
        const userProfile = this.state.fields.profile;
        const errors = {};

        // On récupère les champs à validé dans le formulaire
        // Remarque: Tous les champs sont identiques en édition d'ou la différence si dessous
        const requiredFields = requiredFieldsForm[userProfile]

        // Pour chaque champs required (en fonction du profil)
        // on valide les champs
        requiredFields.forEach(field => {
            // On vérifie le champ
            const errorMessage = validateField[field](this.state.fields[field]);

            // Si il possède une erreur on l'ajoute dans l'objet d'erreur
            if (errorMessage) {
                errors[field] = errorMessage;
            }
        });
        
        let profilIsValid = (Object.keys(errors).length === 0)
        if (userProfile === PROFILES.USER) {
            profilIsValid = profilIsValid && this.state.fields.shopList.length > 0;
            profilIsValid = profilIsValid && this.state.fields.clientList.length === 1;
        } else if(userProfile === PROFILES.SUPER_USER) {
            profilIsValid = profilIsValid && this.state.fields.buList.length > 0;
            profilIsValid = profilIsValid && this.state.fields.clientList.length === 1;
        } else if(userProfile === PROFILES.ADMIN){
            profilIsValid = profilIsValid && this.state.fields.clientList.length > 0;
        }

        // Si l'object erreur possède ne serait ce qu'une clé alors
        // le formulaire n'est pas valide
        this.setState({
            isValid: profilIsValid,
            errors
        });
    };

    /*************************************************
     ******************* WebServices *******************
     *************************************************/

    /**
     * Récupération de la liste des shops pour le dropdown
     * et séléction automatique du premier shop récupéré
     * @param idBu
     */
    getShopList = (idBu) => {
        const getShopListPromise = ShopService.getShopList(idBu);
        const cancelablePromise = makeCancelable(getShopListPromise);
        this._promises.push(cancelablePromise);

        cancelablePromise
            .promise
            .then(res => {
                this.setState((state) => {
                    let fields = {...state.fields};
                    fields.shop = undefined;
                    return {
                        shopList: res.shopList,
                        fields
                    }
                }, () => this.selectShop(res.shopList[0]));
            })
            .catch((error) => {
                if (!error.isCanceled) {
                    this.setState({error: error.message});
                }
            })
            .then(() => this.promiseFulfilled(cancelablePromise));
    };

    /**
     * Récupération de la liste des shops pour le dropdown
     * et séléction automatique du premier shop récupéré
     * @param idBu
     */
    getShopListWithoutSelect = (idBu) => {
      const getShopListPromise = ShopService.getShopList(idBu);
      const cancelablePromise = makeCancelable(getShopListPromise);
      this._promises.push(cancelablePromise);

      cancelablePromise
        .promise
          .then(res => {
            this.setState({
              shopList: res.shopList
            });
          })
          .catch((error) => {
            if (!error.isCanceled) {
              this.setState({error: error.message});
            }
          })
          .then(() => this.promiseFulfilled(cancelablePromise));
    };

    /**********************************************************
     * ************** Gestion des promises ******************
     **********************************************************/

    _promises = [];

    /**
     * On retire la promise de la liste des promises en cours
     * Cette fonction doit etre appelé après que la promise est rempli
     * @param promise
     */
    promiseFulfilled = (promise) => {
        const index = this._promises.indexOf(promise);

        if (index !== -1) {
            this._promises.splice(index, 1);
        }
    };

}

UserForm.defaultProps = {
    isCreating: false,
    isAdmin: false,
    profileMap: {},
    userData: {},
    userFormError: null
};

export default UserForm;



// WEBPACK FOOTER //
// ./src/components/userForm/UserForm.js